export const id = {
  inputElements: {
    typeElements: {
      input: 'Masukan',
      typography: 'Tipografi',
      layout: 'Tata Letak',
      action: 'Aksi',
    },
  },
  panels: {
    Component: 'Komponen',
    Layer: 'Lapisan',
    Design: 'Desain',
  },
  designPanel: {
    title: 'Tampilan Dasar',
    fontFamily: 'Jenis Font',
    fontSize: 'Ukuran Font',
    labelFormat: 'Format Label',
    labelAllignment: 'Perataan Label',
    textColor: 'Warna Teks',
    backgroundColor: 'Warna Latar',
  },
  componentPanel: {
    searchPlaceholder: 'Cari komponen...',
  },
  tabPreviewForm: {
    'Form Definition': 'Definisi Form',
    'Form Preview': 'Pratinjau Form',
  },
}
